import React from 'react';
import { useSelector } from 'react-redux';
import ConfirmAndSendModal from '../presentational/ConfirmAndSendModal';

const ConfirmAndSendModalContainer = ({
    selectedPayee,
    form,
    handleSubmit,
    error,
    hideModal,
    postingSelector,
    type,
}) => {
    const isPosting = useSelector(postingSelector);

    const handleClose = () => hideModal();

    return (
        <ConfirmAndSendModal
            {...form}
            selectedPayee={selectedPayee}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            isError={error}
            type={type}
        />
    );
};

export default ConfirmAndSendModalContainer;
